<script lang="ts" setup>
</script>

<template>
  <div class="flex flex-col min-h-0 h-dvh">
    <div class="relative md:mx-auto md:w-full md:max-w-full flex flex-col flex-1 min-h-0">
      <header v-if="$slots.header" class="shrink-0 mb-4 absolute inset-x-0 top-4 left-4 z-30">
        <slot name="header" />
      </header>
      <div class="flex flex-col flex-1 min-h-0">
        <slot name="activity" />
      </div>
    </div>
  </div>
  <div id="learn-teleport" />
</template>
